module.exports = [{
  plugin: require('/Users/bm/work/mdx-deck-example/stack/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
  options: {
    "plugins": [],
    "gatsbyRemarkPlugins": ["gatsby-remark-import-code"],
    "remarkPlugins": [null, null]
  }
}, {
  plugin: require('/Users/bm/work/mdx-deck-example/stack/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
  options: {
    "plugins": []
  }
}, {
  plugin: require('/Users/bm/work/mdx-deck-example/stack/node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
  options: {
    "plugins": []
  }
}, {
  plugin: require('/Users/bm/work/mdx-deck-example/stack/node_modules/gatsby-theme-mdx-deck/gatsby-browser.js'),
  options: {
    "plugins": [],
    "cli": true,
    "contentPath": "/Users/bm/work/mdx-deck-example/stack/deck.mdx"
  }
}];